export default __webpack_public_path__ + "static/media/mobile5.ce49a5fe.webp";